import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function CBCombine() {
  return <section className="bg-[#FF1493] py-[60px] lg:py-[100px]" data-id="element-442">
      <div className="max-w-[1000px] mx-auto px-6 lg:px-8" data-id="element-443">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-444">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-10 font-[600] font-[Poppins,_sans-serif]" data-id="element-445">
            COMBINE TREATMENTS FOR BEAUTIFUL RESULTS
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full mb-10" data-id="element-446">
            <div className="bg-white p-9 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-447">
              <h3 className="text-black text-xl font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-448">
                SkinTyte
              </h3>
              <p className="text-[#333333] text-sm leading-[1.6] font-body" data-id="element-449">
                SkinTyte uses light energy to heat and stimulate your skin cells
                and make your skin tighter because it stimulates the body's
                natural collagen production. The result is the appearance of
                smoother, firmer, and tighter skin with a more youthful tone.
              </p>
            </div>

            <div className="bg-white p-9 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-450">
              <h3 className="text-black text-xl font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-451">
                ClearSilk
              </h3>
              <p className="text-[#333333] text-sm leading-[1.6] font-body" data-id="element-452">
                The primary benefit of a non-ablative laser facial like
                ClearSilk is its ability to rejuvenate the skin without causing
                significant damage or downtime, resulting in smoother, more
                youthful-looking skin with minimal discomfort and recovery time.
              </p>
            </div>
          </div>

          <p className="font-serif italic text-white text-2xl lg:text-[28px]" data-id="element-453">
            Treat yourself!
          </p>
        </AnimateOnScroll>
      </div>
    </section>;
}